<div class="col px-lg-5 px-2">
	<app-nav-prestation
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="openModalAjout()"
	></app-nav-prestation>

	<!-- <div class="row mb-5 d-flex justify-content-start">
		<button
			*ngIf="isAddable"
			class="col-lg-2 col-5 my-2 mx-2 btn theme-green-button"
			(click)="openModalAjout()"
		>
			<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i> Ajouter
		</button>
	</div> -->

	<div class="my-3">
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="onPageChange($event)"
				previousLabel="Précédent"
				nextLabel="Suivant"
				>
			</pagination-controls>
			<div class="d-flex justify-content-center">
				<label class="form-label mt-2 mx-2">Elements par page</label>
				<div class="">
					<select
						[(ngModel)]="itemsPerPage"
						#ctrl="ngModel"
						(change)="onItemsPerPageChange()"
						[ngModelOptions]="{ standalone: true }"
						class="form-select"
					>
						<option [value]="5">5</option>
						<option [value]="10">10</option>
						<option [value]="25">25</option>
						<option [value]="50">50</option>
						<option [value]="100">100</option>
					</select>
				</div>
			</div>
		</div>
		<div class="my-2">
			<div class="row mt-4">
				<div class="col-2 ms-lg-auto">
					<div class="dropdown">
						<a
							class="btn btn-secondary dropdown-toggle"
							role="button"
							id="dropdownFilter"
							data-bs-toggle="dropdown"
							data-bs-auto-close="outside"
							aria-expanded="false"
						>
							<i class="bi bi-filter" aria-hidden="true"></i> Filtrer
						</a>
						<div
						class="dropdown-menu px-3 py-3"
						aria-labelledby="dropdownFilter"
						id="menuFilter">
							<div class="row">
								<span class="theme-main-color form-label">Statut(s) :</span>
								<div class="">
									<div
										*ngFor="let statut of PrestationStatutStringEnum | keyvalue"
										class="form-check"
									>
										<input
											(change)="changeStatusFilter($event, statut.key)"
											class="form-check-input"
											type="checkbox"
											value="{{ statut.key }}"
											id="dd{{ statut.key }}"
										/>
										<label class="form-check-label" for="dd{{ statut.key }}">
											{{ statut.value }}
										</label>
									</div>
								</div>
							</div>
							<br/>
							<div class="row">
								<span class="theme-main-color form-label">Type(s) de prestation:</span>
								<div class="">
									<div
										*ngFor="let type of PrestationTypeStringEnum | keyvalue"
										class="form-check"
									>
										<input
											(change)="changeTypeFilter($event, type.key)"
											class="form-check-input"
											type="checkbox"
											value="{{ type.key }}"
											id="dd{{ type.key }}"
										/>
										<label class="form-check-label" for="dd{{ type.key }}">
											{{ type.value }}
										</label>
									</div>
								</div>
								<div class="row d-flex flex-row-reverse">
									<button
										class="btn theme-green-button w-50"
										(click)="filterListByStatus()"
									>
										Filtrer
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="col-lg-3 col-12">
					<div class="input-group">
						<span class="input-group-text bg-transparent"
							><i class="bi bi-search" aria-hidden="true"></i
						></span>
						<input
							type="text"
							class="form-control border-start-0"
							placeholder="Rechercher un élément..."
							[(ngModel)]="searchedInput"
							(ngModelChange)="onInputChange()"
						/>
					</div>
				</div>
			</div>
		</div>

		<div class="row mt-4 mb-1">
			<div class="col-1">
				<span
					class="hand-cursor fw-bold limitLineSpan"
					>Statut
				</span>
			</div>
			<div class="col-2">
				<span
					class="hand-cursor fw-bold limitLineSpan"
					>Type de prestation
				</span>
			</div>
			<div class="col-1">
				<span
					class="hand-cursor fw-bold limitLineSpan"
					>N° du dossier DH
				</span>
			</div>
			<div class="col-1 d-flex justify-content-around">
				<span
					class="hand-cursor fw-bold flex-grow-1 text-center limitLineSpan"
					>Date de démarrage
				</span>
			</div>
			<div class="col-1 fw-bold">
				<span
					class="hand-cursor fw-bold flex-grow-1 text-center limitLineSpan"
					(click)="sortChange('dateLimite')"
					>Date de limite d'exécution
				</span>
			</div>
			<div class="col-1 fw-bold">
				<span
					class="hand-cursor fw-bold flex-grow-1 text-center limitLineSpan"
					>Durée prévisionnelle
				</span>
			</div>
			<div class="col-1 fw-bold">
				<span
					class="hand-cursor fw-bold flex-grow-1 text-center limitLineSpan"
					>Heures consommées
				</span>
			</div>
			<div class="col-2 fw-bold">
				<span
					class="hand-cursor fw-bold flex-grow-1 text-center limitLineSpan"
					(click)="sortChange('intervenant')"
					>Intervenant
				</span>
			</div>
			<div class="col-2">
				<span
					class="hand-cursor fw-bold limitLineSpan"
					(click)="sortChange('beneficiaire.lastName')"
					>Bénéficiaire
					<span
						*ngIf="sortType === 'beneficiaire.lastName' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'beneficiaire.lastName' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
		</div>

		
		<div class="mt-4" *ngIf="isListingLoading">
			<app-loading></app-loading>
		</div>

		<!-- DEBUT DU LISTING -->
		<div *ngIf="!isListingLoading" class="mt-4">
			<div
				*ngFor="
					let prestation of prestations
						| filterPrestation: searchedInput : isIntervenant
						| paginate
							: {
									itemsPerPage: itemsPerPage,
									currentPage: currentPage,
									totalItems: totalItems
							  }
				"
				class="row my-1 pt-3 pb-1 rounded rounded-3"
			>
				<span class="col-lg-1 col-12 limitLineSpan">
					<div class="btn btn-secondary" style="width: 2px;"
					[ngStyle]="{'background-color':PrestationStatutColor[prestation.statut]}"></div>
					<span class="fw-bold" *ngIf="isMobile">Statut: </span>
					{{
						PrestationStatutStringEnum[prestation.statut]
					}}
				</span>	
				<span class="col-lg-2 col-12 limitLineSpan">
					<span class="fw-bold" *ngIf="isMobile">Type: </span>
					{{
						PrestationTypeStringEnum[prestation.typePrestation]
					}}
				</span>		
				<span class="col-lg-1 col-12 limitLineSpan">
					<span class="fw-bold" *ngIf="isMobile">Numéro dossier: </span>
					{{
						prestation.numeroCommande
					}}
				</span>			  	
				<span [ngClass]="{ row: isMobile }" class="col-lg-1 d-flex limitLineSpan">
					<span class="flex-grow-1 text-lg-center">
						<span class="fw-bold limitLineSpan" *ngIf="isMobile">Date: </span>
						{{ prestation?.dateDebut | date: 'dd/MM/yyyy' }}
					</span>
				</span>
				<span class="col-lg-1 col-12 limitLineSpan">
					<span class="flex-grow-1 text-lg-center">
						<span class="fw-bold limitLineSpan" *ngIf="isMobile">Date: </span>
						{{ prestation?.dateLimite | date: 'dd/MM/yyyy' }}
					</span>
				</span>
				<span class="col-lg-1 col-12 limitLineSpan">
					<span class="flex-grow-1 text-lg-center">
						<span class="fw-bold limitLineSpan" *ngIf="isMobile">Durée prévisionnelle: </span>
						{{ prestation?.dureePrevisionnelle}}
					</span>
				</span>
				<span class="col-lg-1 col-12 limitLineSpan">
					<span class="flex-grow-1 text-lg-center">
						<span class="fw-bold limitLineSpan" *ngIf="isMobile">Heures consommées: </span>
						{{ calculateConsumedHours(prestation)}}
					</span>
				</span>
				<span class="col-lg-2 col-12 limitLineSpan">
					<span class="flex-grow-1 text-lg-center">
						<span *ngIf="prestation.intervenant">
						<span class="fw-bold limitLineSpan" *ngIf="isMobile">Intervenant: </span>
						{{ prestation.intervenant?.firstName +
							' ' +
							prestation.intervenant?.lastName }}
						</span>
					</span>
				</span>
				<div class="col-lg-2">
					<div class="d-flex">
						<span class="flex-grow-1 limitLineSpan"
							><span *ngIf="prestation.beneficiaire">
								<span class="fw-bold limitLineSpan" *ngIf="isMobile">Bénéficiaire: </span>
								{{
									prestation.beneficiaire?.firstName +
										' ' +
										prestation.beneficiaire?.lastName
								}}
							</span></span
						>
						
						<i *ngIf="!prestation.sychroIsyplanning"
							(click)="synchroWithIsyplanning()"
							role="button"
							class="fs-4 bi bi-arrow-repeat mb-4 me-1"
							aria-hidden="true"
						></i>
						<i
							class="fs-4 bi bi-caret-right-fill mb-2"
							aria-hidden="true"
							[routerLink]="['/prestation/appuis-specifiques', prestation?.id]"
							role="button"
						></i>

						<!-- <i
							class="fs-4 bi bi-caret-right-fill mb-1"
							aria-hidden="true"
							*ngIf="
								!isProjectManager &&
								prestation.missionType?.type === missionTypeName.REUNION
							"
							[routerLink]="['/gestion/meeting', prestation?.id]"
							role="button"
						></i> -->
					</div>
				</div>
			</div>
		</div>

		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="onPageChange($event)"
				previousLabel="Précédent"
				nextLabel="Suivant"
				>
			</pagination-controls>
			<div class="d-flex justify-content-center">
				<label class="form-label mt-2 mx-2">Elements par page</label>
				<div class="">
					<select
						[(ngModel)]="itemsPerPage"
						#ctrl="ngModel"
						(change)="onItemsPerPageChange()"
						[ngModelOptions]="{ standalone: true }"
						class="form-select"
					>
						<option [value]="5">5</option>
						<option [value]="10">10</option>
						<option [value]="25">25</option>
						<option [value]="50">50</option>
						<option [value]="100">100</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- <ng-template #modalSuppressionMultiple>
	<div class="modal-header">
		<h4 class="modal-title pull-left">
			Suppression de {{ labelInterventionPluralized }}
		</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="modalSuppressionMultipleRef?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="row my-2">
			<div class="col-5">
				<span class="theme-main-color">Période :</span>
			</div>
			<div class="col">
				<span class="theme-main-color"
					>Du
					{{
						dateRange.value[0].getDate() +
							' ' +
							monthsFr[dateRange.value[0].getMonth()] +
							'
					' +
							dateRange.value[0].getFullYear()
					}}</span
				>
				<span class="mx-2 theme-main-color"
					>au
					{{
						dateRange.value[1].getDate() +
							' ' +
							monthsFr[dateRange.value[1].getMonth()] +
							'
					' +
							dateRange.value[1].getFullYear()
					}}</span
				>
			</div>
		</div>
		<div class="row my-2">
			<div class="col-5">
				<span class="theme-main-color">Compétences sélectionnées :</span>
			</div>
			<div class="col">
				<span
					class="theme-main-color"
					*ngIf="
						selectedCompetences.length === 0 || selectedCompetences.length === 3
					"
					>Toutes</span
				>
				<div
					*ngIf="
						!(
							selectedCompetences.length === 0 ||
							selectedCompetences.length === 3
						)
					"
				>
					<span
						class="theme-main-color"
						*ngFor="let comp of selectedCompetences"
						class="me-2"
						>{{ competences[comp] }}</span
					>
				</div>
			</div>
		</div>
		<div class="row my-2">
			<div class="col-5">
				<span class="theme-main-color">Total :</span>
			</div>
			<div class="col">
				<span class="theme-main-color"
					>{{ listSelectedMissionRequestDelete.length }}
					{{ labelInterventionPluralized }}</span
				>
			</div>
		</div>
		<div class="row mt-4 mb-2">
			<span class="theme-main-color"
				>Si ces informations vous semblent correctes valider la suppression
				<span class="theme-red-color fw-bold"
					>(cette action est irréversible)</span
				></span
			>
		</div>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-main-color-button"
			data-bs-dismiss="modal"
			(click)="modalSuppressionMultipleRef?.hide()"
		>
			Annuler
		</button>
		<button
			type="button"
			class="btn theme-red-button"
			(click)="validateDeleteListSelectedMission()"
			[disabled]="isBtnValidateDeleteListClicked"
		>
			Supprimer
		</button>
	</div>
</ng-template> -->

<!-- <ng-template #modalSuppressionAssignedToPlanning>
	<div class="modal-header">
		<h4 class="modal-title text-center">
			Une ou plusieurs {{ labelInterventionPluralized }} sont affectées dans le
			planning, voulez-vous vraiment les supprimer ?
		</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="modalSuppressionAssignedToPlanningRef?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="d-flex justify-content-evenly">
			<button
				class="btn theme-main-color-button"
				(click)="modalSuppressionAssignedToPlanningRef?.hide()"
			>
				Non
			</button>
			<button
				class="btn theme-red-button"
				(click)="
					deleteMissionsAssignedToPlanning = true;
					modalSuppressionAssignedToPlanningRef?.hide()
				"
			>
				Oui
			</button>
		</div>
	</div>
</ng-template> -->
